module.exports = __webpack_public_path__ + "img/awards_firstplace.e5db36de.png";